module.exports = __webpack_public_path__ + "img/建模.d9297ecd.png";